import { render } from "./ProjectActivityReport.vue?vue&type=template&id=224efca2&scoped=true"
import script from "./ProjectActivityReport.vue?vue&type=script&lang=js"
export * from "./ProjectActivityReport.vue?vue&type=script&lang=js"

import "./time-reports.scss?vue&type=style&index=0&id=224efca2&lang=scss&scoped=true"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224efca2"]])

export default __exports__